function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.167245 6.13664L5.3183 11.286C5.54433 11.5114 5.91053 11.5114 6.13712 11.286C6.36315 11.0605 6.36315 10.6943 6.13712 10.4689L1.39464 5.72811L6.13655 0.987346C6.36258 0.761891 6.36258 0.395695 6.13655 0.16967C5.91053 -0.0557843 5.54376 -0.0557843 5.31773 0.16967L0.166674 5.31901C-0.0559258 5.54214 -0.0559258 5.91409 0.167245 6.13664Z",
  fill: "#6D7F92"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.6
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.92966 6.20112L9.60899 9.87922C9.77043 10.0403 10.032 10.0403 10.1939 9.87922C10.3553 9.71818 10.3553 9.45661 10.1939 9.29557L6.80637 5.90931L10.1934 2.52305C10.3549 2.36201 10.3549 2.10044 10.1934 1.93899C10.032 1.77796 9.77003 1.77796 9.60858 1.93899L5.92925 5.6171C5.77025 5.77647 5.77025 6.04215 5.92966 6.20112Z",
  fill: "#6D7F92"
})));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 8.18182,
  height: 8.18182,
  fill: "white",
  transform: "translate(12.1533 10) rotate(-180)"
})));

var SvgChevronLeftGray = function SvgChevronLeftGray(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChevronLeftGray, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chevron-left-gray.c6817c7e.svg";
export { ForwardRef as ReactComponent };